import React, { useState } from "react";
import MainCalculatorsList from "./CountriesMainCalculatorsList/SyriaMainCalculator";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة فاتورة الكهرباء في سوريا - احسب تكلفة استهلاكك الشهري";
const DESCRIPTION =
  "احسب قيمة فاتورة الكهرباء بدقة باستخدام التعريفة الرسمية الجديدة. أدخل استهلاكك واحصل على حساب تفصيلي فوري للشريحتين - أداة مجانية سهلة الاستخدام";
const KEYWORDS = "حاسبة فاتورة الكهرباء, حساب استهلاك الكهرباء سوريا, تعريفة الكهرباء الجديدة, أسعار الطاقة الكهربائية, كيلووات ساعة";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SY/calculators-list/electricity-calculator/";
// بيانات الأجهزة المنزلية
const APPLIANCES_DATA = {
  heating: [
    { name: "مكيف تبريد وتدفئة", power: 1800, hours: 6, emoji: "🌡️" },
    { name: "دفاية كهربائية", power: 2200, hours: 5, emoji: "🔥" },
    { name: "سخان ماء فوري", power: 2500, hours: 1.5, emoji: "💧" },
  ],
  kitchen: [
    { name: "ثلاجة عادية", power: 180, hours: 24, emoji: "🧊" },
    { name: "فرن كهربائي", power: 2800, hours: 0.8, emoji: "🍕" },
    { name: "ميكروويف", power: 1100, hours: 0.4, emoji: "🍲" },
  ],
  laundry: [
    { name: "غسالة أوتوماتيك", power: 700, hours: 1, emoji: "👕" },
    { name: "نشافة ملابس", power: 3500, hours: 0.8, emoji: "🌪️" },
    { name: "مكواة بخار", power: 1400, hours: 0.4, emoji: "👔" },
  ],
  electronics: [
    { name: "تلفزيون LED", power: 120, hours: 6, emoji: "📺" },
    { name: "كمبيوتر مكتبي", power: 250, hours: 8, emoji: "🖥️" },
    { name: "لابتوب", power: 70, hours: 5, emoji: "💻" },
    { name: "راوتر إنترنت", power: 12, hours: 24, emoji: "📡" },
  ]
};
function ElectricityCalculator() {
  const [consumption, setConsumption] = useState("");
  const [usageType, setUsageType] = useState("residential");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [applianceHours, setApplianceHours] = useState({});
  // التاريخ الحالي
  const today = new Date().toLocaleDateString('ar-SY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const calculateBill = () => {
    try {
      setError("");
      const kwh = parseFloat(consumption);
      if (isNaN(kwh) || kwh <= 0) {
        setError("يرجى إدخال قيمة استهلاك صالحة");
        return;
      }
      let totalCost = 0;
      let tier1Cost = 0;
      let tier2Cost = 0;
      let tier1Kwh = 0;
      let tier2Kwh = 0;
      if (usageType === "residential") {
        if (kwh <= 300) {
          tier1Kwh = kwh;
          tier1Cost = kwh * 6;
          totalCost = tier1Cost;
        } else {
          tier1Kwh = 300;
          tier2Kwh = kwh - 300;
          tier1Cost = 300 * 6;
          tier2Cost = (kwh - 300) * 14;
          totalCost = tier1Cost + tier2Cost;
        }
      } else {
        totalCost = kwh * 14;
      }
      setResult({
        totalCost,
        tier1Cost,
        tier2Cost,
        tier1Kwh,
        tier2Kwh,
        totalKwh: kwh,
        totalCostOld: totalCost * 100,
        tier1CostOld: tier1Cost * 100,
        tier2CostOld: tier2Cost * 100
      });
    } catch (error) {
      setError("حدث خطأ في الحساب");
    }
  };
  const updateApplianceHours = (category, name, hours) => {
    const id = `${category}-${name}`;
    const updatedHours = {
      ...applianceHours,
      [id]: parseFloat(hours) || 0
    };
    setApplianceHours(updatedHours);
    let total = 0;
    Object.entries(APPLIANCES_DATA).forEach(([cat, appliances]) => {
      appliances.forEach(app => {
        const appId = `${cat}-${app.name}`;
        const hrs = updatedHours[appId] || 0;
        if (hrs > 0) {
          const daily = (app.power * hrs) / 1000;
          total += daily * 30;
        }
      });
    });
    if (total > 0) {
      setConsumption(total.toFixed(1));
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
         <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p>
                  هل تريد معرفة القيمة المتوقعة لفاتورتك الشهرية؟ أداتنا توفر لك حساباً
                  دقيقاً لتكلفة استهلاك الكهرباء وفق التعريفة الرسمية المعتمدة. ببساطة،
                  أدخل استهلاكك الشهري بالكيلووات ساعة واحصل فوراً على التفاصيل الكاملة
                  للفاتورة مع توزيع التكلفة على الشرائح المختلفة.
                </p>
                <p>
                  تعتمد الحاسبة على نظام التسعير الرسمي المعتمد من الجهات المختصة في سوريا،
                  والذي يقسم الاستهلاك المنزلي إلى شريحتين بأسعار متفاوتة. الاستهلاك حتى 300
                  كيلووات يخضع لسعر أقل، بينما ما يزيد عن ذلك يُحتسب بتعريفة أعلى. هذا النظام
                  يشجع المواطنين على ترشيد الاستهلاك وتخفيض الفواتير.
                </p>
                <p>
                  معرفة تفاصيل فاتورتك تساعدك على التخطيط المالي الأفضل وفهم كيفية توزيع
                  التكاليف. كما يمكنك استخدام قسم حساب استهلاك الأجهزة أدناه لمعرفة مقدار
                  الطاقة التي يستهلكها كل جهاز في منزلك، مما يساعدك على اتخاذ قرارات ذكية
                  لتوفير الطاقة والمال.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u><b>ملاحظة هامة</b>:</u>{" "}
                  <b>
                    تاريخ آخر تحديث: <time dateTime={new Date().toISOString().split('T')[0]}>{today}</time>
                  </b>
                </div>
                <div className="p-3">
                  <div className="form-group mb-3">
                    <label><strong>نوع الاشتراك:</strong></label>
                    <select
                      className="form-control"
                      value={usageType}
                      onChange={(e) => setUsageType(e.target.value)}
                    >
                      <option value="residential">🏠 سكني (منزلي)</option>
                      <option value="industrial">🏭 صناعي / تجاري</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="consumption"><strong>الاستهلاك الشهري (كيلووات ساعة):</strong></label>
                    <input
                      id="consumption"
                      type="number"
                      value={consumption}
                      onChange={(e) => setConsumption(e.target.value)}
                      className="form-control mb-2"
                      placeholder="مثال: 350"
                    />
                  </div>
                  {usageType === "residential" && (
                    <div className="alert alert-info">
                      <strong>📊 نظام الشرائح:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "10px", paddingRight: "20px" }}>
                        <li>الشريحة الأولى (0-300 كيلووات): <strong>6 ل.س</strong> <small className="text-muted">(600 ل.س العملة القديمة)</small></li>
                        <li>الشريحة الثانية (+300 كيلووات): <strong>14 ل.س</strong> <small className="text-muted">(1,400 ل.س العملة القديمة)</small></li>
                      </ul>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white"
                    style={{ fontSize: "20px", marginLeft: "10px", padding: "10px 30px", border: "none", borderRadius: "5px", backgroundColor: "#0d5e3a" }}
                    onClick={calculateBill}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  result !== null && (
                     <div className="bg-success text-white text-center">
                      <p style={{ fontSize: "18px", marginBottom: "10px" }}>
                        <strong>💰 التكلفة الإجمالية: {result.totalCost.toLocaleString()} ل.س</strong>
                        <br />
                        <small style={{ fontSize: "13px", opacity: 0.9 }}>
                          ({result.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                        </small>
                      </p>
                      {usageType === "residential" && (
                        <div style={{ fontSize: "14px" }}>
                          {result.tier1Kwh > 0 && (
                            <p>
                              الشريحة الأولى: {result.tier1Kwh} كيلووات × 6 = {result.tier1Cost.toLocaleString()} ل.س
                              <br />
                              <small style={{ fontSize: "12px", opacity: 0.85 }}>
                                ({result.tier1CostOld.toLocaleString()} ل.س العملة القديمة)
                              </small>
                            </p>
                          )}
                          {result.tier2Kwh > 0 && (
                            <p>
                              الشريحة الثانية: {result.tier2Kwh} كيلووات × 14 = {result.tier2Cost.toLocaleString()} ل.س
                              <br />
                              <small style={{ fontSize: "12px", opacity: 0.85 }}>
                                ({result.tier2CostOld.toLocaleString()} ل.س العملة القديمة)
                              </small>
                            </p>
                          )}
                        </div>
                      )}
                      {usageType === "industrial" && (
                        <div style={{ fontSize: "14px" }}>
                          <p>
                            تعريفة موحدة: {result.totalKwh} كيلووات × 14 = {result.totalCost.toLocaleString()} ل.س
                            <br />
                            <small style={{ fontSize: "12px", opacity: 0.85 }}>
                              ({result.totalCostOld.toLocaleString()} ل.س العملة القديمة)
                            </small>
                          </p>
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
              <div className="col-sm-12 col-md-5">
                {/* جدول الأسعار الرسمية */}
                <div className="calculatorStyle">
                   <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>📋 جدول الأسعار الرسمية</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-3">
                      <strong>🏠 الاستخدام المنزلي</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>0-300 كيلووات</td>
                            <td style={{ width: "50%" }}>
                              <strong>6 ل.س</strong>
                              <br />
                              <small className="text-muted">(600 ل.س القديمة)</small>
                            </td>
                          </tr>
                          <tr>
                            <td>+300 كيلووات</td>
                            <td>
                              <strong>14 ل.س</strong>
                              <br />
                              <small className="text-muted">(1,400 ل.س القديمة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <strong>🏭 الاستخدام الصناعي</strong>
                      <table className="table table-sm mt-2" style={{ tableLayout: "fixed" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>جميع الاستهلاك</td>
                            <td style={{ width: "50%" }}>
                              <strong>14 ل.س</strong>
                              <br />
                              <small className="text-muted">(1,400 ل.س القديمة)</small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                {/* أمثلة سريعة */}
                <div className="calculatorStyle">
                   <div className="bg-success text-white text-center">
                    <h3 style={{ fontSize: "16px", margin: 0 }}>🧮 أمثلة سريعة</h3>
                  </div>
                  <div className="p-3">
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>200 كيلووات:</strong>
                      <br />
                      200 × 6 = <strong>1,200 ل.س</strong>
                      <br />
                      <small className="text-muted">(120,000 ل.س العملة القديمة)</small>
                    </div>
                    <div className="mb-2 p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>400 كيلووات:</strong>
                      <br />
                      (300 × 6) + (100 × 14) = <strong>3,200 ل.س</strong>
                      <br />
                      <small className="text-muted">(320,000 ل.س العملة القديمة)</small>
                    </div>
                    <div className="p-2" style={{ border: "2px solid #0d5e3a", borderRadius: "5px" }}>
                      <strong>500 كيلووات:</strong>
                      <br />
                      (300 × 6) + (200 × 14) = <strong>4,600 ل.س</strong>
                      <br />
                      <small className="text-muted">(460,000 ل.س العملة القديمة)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* قسم حساب الاستهلاك من الأجهزة */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>
                    🔌 احسب استهلاكك من أجهزتك المنزلية
                  </h2>
                </div>
                <div className="p-3">
                  <p>حدد ساعات تشغيل أجهزتك اليومية وسيتم حساب الاستهلاك تلقائياً</p>
                  {Object.entries(APPLIANCES_DATA).map(([category, appliances]) => (
                    <div key={category} className="mb-4">
                      <h3 className="bg-success text-white text-center">
                        {category === 'heating' && '🔥 التدفئة والتكييف'}
                        {category === 'kitchen' && '🍳 أجهزة المطبخ'}
                        {category === 'laundry' && '🧺 الغسيل والعناية'}
                        {category === 'electronics' && '📺 الإلكترونيات'}
                      </h3>
                      <div className="row">
                        {appliances.map((app) => {
                          const id = `${category}-${app.name}`;
                          const hours = applianceHours[id] || 0;
                          const monthly = hours > 0 ? ((app.power * hours) / 1000) * 30 : ((app.power * app.hours) / 1000) * 30;
                          const costNew = monthly <= 300 ? monthly * 6 : (300 * 6) + ((monthly - 300) * 14);
                          const costOld = costNew * 100;
                          return (
                            <div className="col-sm-12 col-md-4 mb-3" key={id}>
                              <div style={{ minHeight: "180px", border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                                <div className="bg-success text-white text-center">
                                  <strong style={{ fontSize: "14px" }}>{app.emoji} {app.name}</strong>
                                </div>
                                <div className="p-3">
                                  <small className="text-muted d-block mb-2">
                                    القدرة: {app.power} واط
                                  </small>
                                  <div className="form-group mb-2">
                                    <label style={{ fontSize: "12px" }}>ساعات التشغيل يومياً:</label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={hours || ''}
                                      onChange={(e) => updateApplianceHours(category, app.name, e.target.value)}
                                      placeholder={`مثال: ${app.hours}`}
                                      min="0"
                                      step="0.5"
                                    />
                                  </div>
                                  <div className="d-block" style={{ color: "#0d5e3a" }}>
                                    <small>
                                      الاستهلاك: <strong>{monthly.toFixed(1)} كيلووات/شهر</strong>
                                    </small>
                                    <br />
                                    <small>
                                      التكلفة: <strong>{costNew.toFixed(1)} ل.س</strong>
                                    </small>
                                    <br />
                                    <small className="text-muted">
                                      ({costOld.toFixed(0)} ل.س العملة القديمة)
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr />
            {/* نصائح التوفير */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                 <div className="bg-success text-white text-center">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>نصائح لتوفير الكهرباء</h2>
                </div>
                <div className="p-3">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>عزل المنزل بشكل جيد</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            تحسين العزل الحراري للنوافذ والأبواب يقلل الحاجة للتدفئة والتبريد بنسبة تصل إلى 30%، مما يوفر استهلاك كبير من الطاقة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم الستائر العازلة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الستائر السميكة تحافظ على برودة المنزل صيفاً ودفئه شتاءً، وتخفض حمل المكيف والدفاية بنسبة 25%
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>اغسل بالماء البارد</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            90% من طاقة الغسالة تذهب لتسخين الماء. الغسيل بالماء البارد فعال للملابس ويوفر استهلاك كبير
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>صيانة دورية للثلاجة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            نظف ملفات الثلاجة الخلفية كل 3 أشهر وتأكد من إحكام إغلاق الباب. هذا يحسن الكفاءة بنسبة 20%
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استفد من ضوء النهار الطبيعي</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            افتح الستائر نهاراً واستغل الإضاءة الطبيعية بدلاً من المصابيح، مما يوفر استهلاك الإنارة بشكل كامل خلال النهار
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استبدل الأجهزة القديمة</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            الأجهزة الحديثة ذات تصنيف الطاقة A+++ تستهلك أقل بنسبة 50-70% من الموديلات القديمة، خاصة الثلاجات والمكيفات
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>استخدم مراوح السقف</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            مراوح السقف تستهلك 98% طاقة أقل من المكيف وتوزع الهواء بكفاءة. استخدمها مع المكيف لتخفيض درجة الحرارة المطلوبة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div style={{ border: "2px solid #0d5e3a", borderRadius: "5px", overflow: "hidden" }}>
                        <div className="bg-success text-white text-center">
                          <strong style={{ fontSize: "14px" }}>برمج منظم الحرارة الذكي</strong>
                        </div>
                        <div className="p-3">
                          <p style={{ fontSize: "14px", marginBottom: 0 }}>
                            المنظم الذكي يضبط الحرارة تلقائياً حسب وجودك بالمنزل، مما يوفر 10-15% من استهلاك التدفئة والتبريد
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {/* الأسئلة الشائعة */}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيف يتم احتساب فاتورة الكهرباء؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نظام الشرائح للاستخدام المنزلي</h2>
                  </u>
                  <p>
                    يعتمد النظام على تقسيم الاستهلاك لشريحتين: الأولى من 0 حتى 300
                    كيلووات بسعر 6 ل.س للكيلووات، والثانية لما يزيد عن 300 كيلووات
                    بسعر 14 ل.س للكيلووات.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال حسابي</h2>
                  </u>
                  <p>
                    إذا كان استهلاكك 400 كيلووات/ساعة شهرياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    الشريحة الأولى: 300 × 6 = 1,800 ل.س
                    <br />
                    <small className="text-muted">(180,000 ل.س العملة القديمة)</small>
                    <br />
                    الشريحة الثانية: 100 × 14 = 1,400 ل.س
                    <br />
                    <small className="text-muted">(140,000 ل.س العملة القديمة)</small>
                    <br />
                    <strong>الإجمالي: 3,200 ل.س</strong>
                    <br />
                    <small className="text-muted">(320,000 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أعرف استهلاك كل جهاز؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>معادلة حساب الاستهلاك</h2>
                  </u>
                  <p>
                    لحساب استهلاك أي جهاز: (قدرة الجهاز بالواط × ساعات التشغيل يومياً ÷ 1000) × 30 يوم
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال عملي</h2>
                  </u>
                  <p>
                    مكيف بقدرة 1500 واط يعمل 8 ساعات يومياً:
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    (1500 × 8 ÷ 1000) × 30 = 360 كيلووات شهرياً
                    <br />
                    التكلفة: (300 × 6) + (60 × 14) = 2,640 ل.س
                    <br />
                    <small className="text-muted">(264,000 ل.س العملة القديمة)</small>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">لماذا فاتورتي مرتفعة؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسباب الشائعة</h2>
                  </u>
                  <p>
                    • تجاوز حد 300 كيلووات يضاعف السعر تقريباً
                    <br />
                    • الاستهلاك الخفي من الأجهزة في وضع الاستعداد
                    <br />
                    • زيادة استخدام التدفئة أو التكييف
                    <br />
                    • الأجهزة القديمة تستهلك أضعاف الموديلات الحديثة
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">ما هي أكثر الأجهزة استهلاكاً؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأجهزة ذات الاستهلاك الأعلى</h2>
                  </u>
                  <p>
                    • المكيفات: 300-480 كيلووات شهرياً
                    <br />
                    • السخانات الكهربائية: 120-180 كيلووات
                    <br />
                    • الدفايات: 180-300 كيلووات
                    <br />
                    • الأفران الكهربائية: 60-90 كيلووات
                    <br />
                    • الثلاجات القديمة: 108-180 كيلووات
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيف أخفض فاتورتي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>نصائح عملية</h2>
                  </u>
                  <p>
                    • استبدل المصابيح بـ LED (توفير 50 كيلووات)
                    <br />
                    • قلل ساعات المكيف (توفير 100-150 كيلووات)
                    <br />
                    • استخدم سخان شمسي (توفير 80-120 كيلووات)
                    <br />
                    • افصل الأجهزة غير المستخدمة (توفير 15-30 كيلووات)
                    <br />
                    • استبدل الأجهزة القديمة (توفير 50-100 كيلووات)
                  </p>
                  <br />
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">هل الأجهزة المطفأة تستهلك كهرباء؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الاستهلاك الخفي</h2>
                  </u>
                  <p>
                    نعم! الأجهزة في وضع الاستعداد تستهلك طاقة باستمرار. التلفزيون،
                    أجهزة الألعاب، الشواحن، والميكروويف - كلها تستهلك كهرباء حتى
                    وهي "مطفأة". هذا الاستهلاك الخفي قد يصل لـ 5-10% من فاتورتك!
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <strong>الحل:</strong> استخدم مشتركات بمفتاح أو افصل الأجهزة من الكهرباء
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ElectricityCalculator;